export default function getFileName({ url } = {}) {
  if (!url) return undefined;

  return new URL(url).pathname;
}
